"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterKeysInPlace = exports.compareItems = exports.filterItems = exports.getTextByValue = exports.toText = exports.toItemIntKey = exports.toItemLowercaseKey = exports.toItem = exports.toItemCustom = exports.getDocId = exports.getItemValue = exports.getSelectItems = exports.sortByIndex = exports.sortByIndexComparator = exports.yesNoItems = exports.objectToItemsNumeric = exports.objectToItems = exports.entryToItem = exports.docToItem = exports.Item = void 0;
class Item {
    constructor(value, text, description) {
        this.value = value;
        this.text = text;
        this.description = description;
    }
}
exports.Item = Item;
function docToItem({ id, name }) {
    return { value: id, text: name || String(id) };
}
exports.docToItem = docToItem;
const entryToItem = ([value, text]) => ({
    value,
    text
});
exports.entryToItem = entryToItem;
const objectToItems = (obj) => Object.entries(obj).map(([key, value]) => new Item(key, value));
exports.objectToItems = objectToItems;
const objectToItemsNumeric = (obj) => Object.entries(obj).map(([key, value]) => new Item(Number(key), value));
exports.objectToItemsNumeric = objectToItemsNumeric;
exports.yesNoItems = [
    { value: true, text: "Yes" },
    { value: false, text: "No" }
];
const sortByIndexComparator = (a, b) => a.index - b.index;
exports.sortByIndexComparator = sortByIndexComparator;
function sortByIndex(items) {
    const sortedItems = [...items];
    sortedItems.sort(exports.sortByIndexComparator);
    return sortedItems;
}
exports.sortByIndex = sortByIndex;
function getSelectItems(docs) {
    return sortByIndex(docs).map((doc) => docToItem(doc));
}
exports.getSelectItems = getSelectItems;
function getItemValue(value, items) {
    var _a;
    if (!value) {
        return undefined;
    }
    return (_a = items.find((item) => {
        var _a;
        if (item.value === value) {
            return true;
        }
        if (String(item.value) === String(value)) {
            return true;
        }
        if (item.text && ((_a = item.text) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === String(value).toLowerCase()) {
            return true;
        }
        return false;
    })) === null || _a === void 0 ? void 0 : _a.value;
}
exports.getItemValue = getItemValue;
function getDocId(value, docs) {
    var _a;
    if (!value) {
        return undefined;
    }
    return (_a = docs.find((item) => {
        var _a;
        if (item.id === value) {
            return true;
        }
        if (String(item.id) === String(value)) {
            return true;
        }
        if (((_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === String(value).toLowerCase()) {
            return true;
        }
        return false;
    })) === null || _a === void 0 ? void 0 : _a.id;
}
exports.getDocId = getDocId;
const toItemCustom = ({ integerId, lowerCaseId, additionalFields, valueText } = {}) => (data) => {
    let id;
    if (integerId) {
        id = parseInt(data.id, 10);
    }
    else if (lowerCaseId) {
        id = data.id.toLowerCase();
    }
    else {
        id = String(data.id);
    }
    const item = valueText
        ? { value: id, text: data.name }
        : { id, name: data.name };
    item.description = data.description;
    if (additionalFields) {
        additionalFields.forEach((field) => {
            item[field] = data[field];
        });
    }
    return item;
};
exports.toItemCustom = toItemCustom;
exports.toItem = exports.toItemCustom({ valueText: true });
exports.toItemLowercaseKey = exports.toItemCustom({
    valueText: true,
    lowerCaseId: true
});
exports.toItemIntKey = exports.toItemCustom({ valueText: true, integerId: true });
const toText = ({ name }) => name;
exports.toText = toText;
const getTextByValue = (itemList, value) => {
    const item = itemList.find((aItem) => parseInt(aItem.value, 10) === value) || {};
    if (item) {
        return item.text;
    }
    return null;
};
exports.getTextByValue = getTextByValue;
function filterItems(items, keepKeys) {
    if (keepKeys && keepKeys.length) {
        return items.filter((item) => keepKeys.includes(item.value));
    }
    return items;
}
exports.filterItems = filterItems;
function compareItems(a, b) {
    if (a.text < b.text) {
        return -1;
    }
    if (a.text > b.text) {
        return 1;
    }
    return 0;
}
exports.compareItems = compareItems;
const filterKeysInPlace = (keys, items) => {
    const removeRoles = keys.filter((role) => items.every((option) => option.value !== role));
    removeRoles.forEach((removeRole) => {
        const idx = keys.indexOf(removeRole);
        keys.splice(idx, 1);
    });
};
exports.filterKeysInPlace = filterKeysInPlace;
//# sourceMappingURL=index.js.map